import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=5db25133&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db25133')) {
      api.createRecord('5db25133', component.options)
    } else {
      api.reload('5db25133', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=5db25133&", function () {
      api.rerender('5db25133', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W6Tle6s5Zzth/JS/offershelp.vue"
export default component.exports